export default __webpack_public_path__ + "static/media/CHENNAI-1.c9304180.webp";